window.app = window.app || {};
app.helpers = app.helpers || {};

app.helpers = {
    cookie: {
        set: (key, value, duration) => {
            const cookieName = encodeURIComponent(key);
            const cookieValue = encodeURIComponent(value);

            if (duration === false) {
                document.cookie = `${cookieName}=${cookieValue}; path=/;`;
            } else {
                const date = new Date();
                date.setTime(date.getTime() + duration);
                const expires = "expires=" + date.toUTCString();
                document.cookie = `${cookieName}=${cookieValue}; ${expires}; path=/;`;
            }
        },
        get: (key) => {
            const decodedCookie = decodeURIComponent(document.cookie);
            const cookies = decodedCookie.split(';');
            for (let cookie of cookies) {
                cookie = cookie.trim();
                const parts = cookie.split('=');
                if (parts[0] === key) {
                    return parts[1];
                }
            }
            return null;
        },
        delete: (key) => {
              document.cookie = encodeURIComponent(key) + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        }
    },

    /**
     * Global debounce utility - can be used across the application
     * @param {Function} func - Function to debounce
     * @param {number} wait - Milliseconds to wait
     * @returns {Function} Debounced function
     */
    debounce: (func, wait) => {
        let timeout;
        return function executedFunction(...args) {
            const later = () => {
                clearTimeout(timeout);
                func(...args);
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        };
    }

};

